import ViewPadrao from "../views/ViewPadrao";
import RelatorioContasReceberFiltro from "../views/RelatorioContasReceberFiltro";
import RelatorioVendasFiltro from "../views/RelatorioVendasFiltro";
import RelatorioContasReceberVendedor from "../views/RelatorioContasReceberVendedor"

export default {
  path: "relatorio",
  component: ViewPadrao,
  children: [
    {
      path: "relatorio-vendas",
      name: "vendas-relatorio-1",
      component: RelatorioVendasFiltro,
    },
    {
      path: "relatorio-contas-receber",
      name: "contas-receber-relatorio-1",
      component: RelatorioContasReceberFiltro,
    },
    {
      path: "acompanhamento-comissoes",
      name: "contas-receber-relatorio-vendedor",
      component: RelatorioContasReceberVendedor,
    },
  ],
};
